import { computed, signal } from '@angular/core';

export class ManagementDetailState<T> {
  readonly selected = signal<T | null>(null);
  readonly creating = signal(false);
  readonly open = computed(() => this.creating() || !!this.selected());

  private latestRequestNumber = 0;

  async select(loadDetail: () => Promise<T>) {
    const requestNumber = ++this.latestRequestNumber;
    this.creating.set(false);
    const detail = await loadDetail();
    if (requestNumber === this.latestRequestNumber) this.selected.set(detail);
  }

  startCreation() {
    this.latestRequestNumber++;
    this.selected.set(null);
    this.creating.set(true);
  }

  close() {
    this.latestRequestNumber++;
    this.selected.set(null);
    this.creating.set(false);
  }

  showSaved(detail: T) {
    this.latestRequestNumber++;
    this.creating.set(false);
    this.selected.set(detail);
  }
}
